export default __webpack_public_path__ + "static/media/kitchen3-after1.df01611d.jpg";